const endpoint = {
    get: (baseUrl) => {
        return baseUrl || import.meta.env.VITE_DEFAULT_URL;
    }
};

export default endpoint;